module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Báo cáo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [(_vm.showData) ? _c('gs-table', {
    ref: _vm.invoiceReportTable,
    attrs: {
      "table-name": _vm.invoiceReportTable,
      "data-source": "invoices/report-by-crosscheck",
      "data-params": _vm.filters,
      "cache-data": false,
      "data-sorts": _vm.sorts,
      "data-sorted": _vm.sorted
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.invoiceReportTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.invoiceReportTable].current_page - 1) * _vm.dataPaginations[_vm.invoiceReportTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.cross_check && scope.row.cross_check.data.id) ? _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Mã đối soát"
                }
              }, [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.cross_check.data.id))])])], 1) : _vm._e(), _vm._v(" "), (scope.row.cross_check) ? _c('p', [_vm._v("Ngày: " + _vm._s(scope.row.cross_check.data.created_at))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi",
            "width": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phiếu: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng tiền: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_amount)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi đã thanh toán",
            "width": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phiếu: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_payed)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng tiền: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_amount_payed)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi đã xác nhận",
            "width": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phiếu: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_confirm)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng tiền: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_amount_confirm)))])])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 70991074)
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)])], 1)], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b59de6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceReport.vue
// module id = 630
// module chunks = 1